"use client";

import Link from "next/link";
import { usePostHog } from "posthog-js/react";
import type { ReactNode } from "react";

type Props = {
	href: string;
	companySlug: string;
	locale: string;
	className?: string;
	children: ReactNode;
};

/**
 * Wraps the on-page "jump to open roles" link on the company detail page
 * and fires `company_jobs_link_clicked` on click. Same-zone only (the
 * target is an in-page anchor to the company's own job feed), so a plain
 * next/link is safe — no <ZoneLink> cross-zone handling needed.
 */
export function CompanyJobsLink({
	href,
	companySlug,
	locale,
	className,
	children,
}: Props) {
	const posthog = usePostHog();
	return (
		<Link
			href={href}
			onClick={() =>
				posthog?.capture("company_jobs_link_clicked", {
					company_slug: companySlug,
					locale,
				})
			}
			className={className}
		>
			{children}
		</Link>
	);
}
